// extracted by mini-css-extract-plugin
export default {"noData":"noData_noData__nRR2c"};